import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  public storeDataInLocalStorage(key: string, value: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const currentObj = this.getStorageObject();
    currentObj[key] = value;
    localStorage.setItem(environment.STORAGE_KEY, JSON.stringify(currentObj));
  }

  public getDataFromStorage(key: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    const currentObj = this.getStorageObject();
    return currentObj[key];
  }

  public logout(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.clear();
  }

  private getStorageObject(): Record<string, string> {
    try {
      return JSON.parse(localStorage.getItem(environment.STORAGE_KEY) || '{}');
    } catch {
      return {};
    }
  }
}
